import type { Row, SortingFn } from '@tanstack/vue-table'

// Compare by where the piece sits: difficulty order for song/exercise pieces
// (from the admin-managed difficulties table, enriched onto each piece as
// `difficulty.order`), lesson order for lesson pieces. Ties cascade through
// stars, then lesson position. The cascade always runs, so a multi-sort like
// placement → language behaves as placement → stars → language: stars breaks
// order ties first, then any further user-queued columns break stars ties.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function placementRank(row: Row<any>) {
  const p = row.original
  return {
    // Lesson pieces sort after every difficulty rather than interleaving with
    // them — the two scales aren't comparable.
    group: p?.difficulty?.order ?? (p?.lesson?.order != null ? Number.MAX_SAFE_INTEGER - 1 : Number.MAX_SAFE_INTEGER),
    lesson: p?.lesson?.order ?? 0,
    stars: Number(p?.difficultyStars ?? 0),
    position: p?.lessonOrder ?? 0,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const piecePlacementSortingFn: SortingFn<any> = (rowA: Row<any>, rowB: Row<any>) => {
  const a = placementRank(rowA)
  const b = placementRank(rowB)
  return (
    a.group - b.group ||
    a.lesson - b.lesson ||
    a.stars - b.stars ||
    a.position - b.position
  )
}
